module.exports = "/_next/static/images/empty-card-transaction-01730182518f4f4db4d640fd6f40ede7.svg";